import api from "./axios";

const TechnologiesService = {
	getAll: async () => {
		try {
			const response = await api.get("/technologies");
			return response.data;
		} catch (error) {
			console.error("Error fetching technologies:", error);
			throw error;
		}
	},

	getById: async (id) => {
		try {
			const response = await api.get(`/technologies/${id}`);
			return response.data;
		} catch (error) {
			console.error(`Error fetching technology ${id}:`, error);
			throw error;
		}
	},

	create: async (technologyData) => {
		try {
			const response = await api.post("/technologies", technologyData);
			return response.data;
		} catch (error) {
			console.error("Error creating technology:", error);
			throw error;
		}
	},

	update: async (id, technologyData) => {
		try {
			const response = await api.patch(
				`/technologies/${id}`,
				technologyData
			);
			return response.data;
		} catch (error) {
			console.error(`Error updating technology ${id}:`, error);
			throw error;
		}
	},

	delete: async (id) => {
		try {
			const response = await api.delete(`/technologies/${id}`);
			return response.data;
		} catch (error) {
			console.error(`Error deleting technology ${id}:`, error);
			throw error;
		}
	},
};

export default TechnologiesService;
